import AjaxPage from '../../modules/ajax/ajax-page';
import Component from '../component/component';

import 'tablesaw/dist/tablesaw.jquery.js';
import 'tablesaw/dist/tablesaw-init.js';

import './table.scss';

interface ITableSettings {
    hoverClass: string;
    rowClass: string;
}

interface ISortable {
    ignored: boolean;
    cell: string;
    element: HTMLElement;
}

export default class Table extends Component {
    static initSelector: string = '.table';

    settings: ITableSettings;

    constructor(target: HTMLElement) {
        super(target);

        this.settings = {
            hoverClass: 'is-hovering',
            rowClass: 'table__row',
        };

        this.init();
    }

    init(): void {
        $('th.table__heading[data-tablesaw-sort]').data('tablesaw-sort', this.customSort);

        $('.' + this.settings.rowClass + '[data-href]').on('click', (event: JQuery.TriggeredEvent): void => {
            const url: string = $(event.currentTarget).data('href');
            const isButtonTarget: boolean = $(event.target).hasClass('button') || $(event.target).parents('.button').length > 0;

            if (!isButtonTarget) {
                if (gotoAndPlay.ajax.isEnabled) {
                    AjaxPage.changePage(url);
                } else {
                    window.location = $(event.currentTarget).data('href');
                }
            }
        });

        $('.' + this.settings.rowClass + '[data-href]').on('mouseenter', (event: JQuery.TriggeredEvent): void => {
            $(event.currentTarget).addClass(this.settings.hoverClass);
        });

        $('.' + this.settings.rowClass + '[data-href]').on('mouseleave', (event: JQuery.TriggeredEvent): void => {
            $(event.currentTarget).removeClass(this.settings.hoverClass);
        });
    }

    customSort(ascending: boolean): (a: ISortable, b: ISortable) => number {
        return (a: ISortable, b: ISortable): number => {
            if (a.ignored || b.ignored) {
                return 0;
            }

            const sortA: number = parseInt('' + $(a.element).data('tablesaw-sort'));
            const sortB: number = parseInt('' + $(b.element).data('tablesaw-sort'));
            const isASortable: boolean = !isNaN(sortA);
            const isBSortable: boolean = !isNaN(sortB);

            if (!isASortable || !isBSortable) {
                if (isASortable !== isBSortable) {
                    return isASortable ? -1 : 1;
                }

                return 0;
            }

            if (ascending) {
                return sortA > sortB ? 1 : -1;
            } else {
                return sortA > sortB ? -1 : 1;
            }
        };
    }
}
